<section *ngIf="ticket" class="h-full flex flex-col lg:flex-row gap-2 z-0 relative p-2 lg:pl-0 overflow-hidden">

    <!-- Ticket -->
    <div class="max-h-64 lg:max-h-none lg:w-96 flex flex-col gap-4 p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg overflow-y-auto">
        <div class="flex items-center gap-2">
            <a routerLink="/support/tickets" class="text-sm-light hover:text-zinc-950 dark:hover:text-white" title="Back">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
                </svg>
            </a>
            <h1 class="heading">{{ticket.ticketNumber}}</h1>
        </div>
        <ng-container *ngIf="!isEditing; else editTicket">
            <div class="flex items-start justify-between gap-2">
                <div class="text-sm font-medium text-main-dark">{{ticket.subject}}</div>
                <button *ngIf="canEdit" type="button" (click)="startEdit()" class="btn btn-outline-secondary sm:text-xs/5">Edit</button>
            </div>
            <p *ngIf="ticket.description" class="text-sm-light whitespace-pre-line">{{ticket.description}}</p>
        </ng-container>
        <ng-template #editTicket>
            <div class="space-y-2">
                <input type="text" [(ngModel)]="editForm.subject" placeholder="Subject" />
                <textarea rows="4" [(ngModel)]="editForm.description" placeholder="Description"></textarea>
                <div class="flex justify-end gap-2">
                    <button type="button" (click)="isEditing = false" class="btn btn-outline-secondary sm:text-xs/5">Cancel</button>
                    <button type="button" (click)="saveEdit()" [disabled]="!editForm.subject.trim()" class="btn btn-secondary sm:text-xs/5">Save</button>
                </div>
            </div>
        </ng-template>

        <hr class="w-full border-t border-zinc-950/10 dark:border-white/10" />

        <!-- Status and priority -->
        <div class="grid grid-cols-2 gap-4">
            <div class="space-y-1">
                <label class="subheading">Status</label>
                <select *ngIf="isBrokerStaff; else statusBadge" [ngModel]="ticket.status"
                    (ngModelChange)="updateTicket({ status: $event })">
                    <option *ngFor="let status of statusOptions" [value]="status.value">{{status.label}}</option>
                </select>
                <ng-template #statusBadge>
                    <div>
                        <span [ngClass]="ticket.statusOption?.badge">{{ticket.statusOption?.label}}</span>
                    </div>
                </ng-template>
            </div>
            <div class="space-y-1">
                <label class="subheading">Priority</label>
                <select *ngIf="isBrokerStaff; else priorityBadge" [ngModel]="ticket.priority"
                    (ngModelChange)="updateTicket({ priority: $event })">
                    <option *ngFor="let priority of priorityOptions" [value]="priority.value">{{priority.label}}</option>
                </select>
                <ng-template #priorityBadge>
                    <div>
                        <span [ngClass]="ticket.priorityOption?.badge">{{ticket.priorityOption?.label}}</span>
                    </div>
                </ng-template>
            </div>
        </div>
        <button *ngIf="!isBrokerStaff && ticket.status !== ticketStatus.CLOSED" type="button" (click)="closeTicket()"
            class="btn btn-secondary">
            Close Ticket
        </button>

        <div class="space-y-1">
            <label class="subheading">Raised from</label>
            <div class="text-sm-light">
                {{ticket.createdBy?.name}} · {{roleLabels[ticket.creatorType]}}
            </div>
            <div class="text-xs text-main-light">{{ticket.createdAt | date:'MM/DD/YYYY HHmm'}}</div>
        </div>

        <div *ngIf="ticket.associations.length" class="space-y-1">
            <label class="subheading">Association</label>
            <div *ngFor="let association of ticket.associations" class="flex items-center gap-1 text-sm-light">
                {{association.name | titlecase}}
                <span class="badge text-xs" [ngClass]="association.badge">{{association.short}}</span>
            </div>
        </div>

        <!-- Reference, a ticket not about anything is general -->
        <div class="space-y-1">
            <label class="subheading">Regarding</label>
            <div>
                <a *ngIf="ticket.reference; else general" href="javascript:void(0)" (click)="openReference()" class="text-sm font-medium underline text-main-primary">
                    {{ticket.reference.title}} {{ticket.reference.label}}
                </a>
                <ng-template #general>
                    <span class="text-sm-light">General</span>
                </ng-template>
            </div>
        </div>

        <!-- Attachments -->
        <div *ngIf="ticket.attachments?.length" class="space-y-1">
            <label class="subheading">Attachments</label>
            <a *ngFor="let attachment of ticket.attachments" [href]="attachment.url" target="_blank" rel="noopener"
                class="block underline text-sm break-all">
                {{attachment.name}}
            </a>
        </div>
    </div>

    <!-- Chat -->
    <div class="flex-1 min-h-0 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 overflow-hidden">
        <app-chat-thread [chatId]="ticket.chat" [currentUser]="currentUser" [isClosed]="ticket.status === ticketStatus.CLOSED" class="flex-1 min-h-0"></app-chat-thread>
    </div>
</section>

<app-trip-detail-modal *ngIf="tripId" [tripId]="tripId" [source]="tripSource" (closeModal)="tripId = null"></app-trip-detail-modal>
<app-support-reference-detail *ngIf="selectedReference" [reference]="selectedReference" (closeModal)="selectedReference = null"></app-support-reference-detail>
